import { render } from "./Moneda.vue?vue&type=template&id=41af2286"
import script from "./Moneda.vue?vue&type=script&lang=js"
export * from "./Moneda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__